import type {} from "@mui/material/themeCssVarsAugmentation"
import { createTheme } from "@mui/material/styles"
import { colorSchemes, typography, shadows, shape } from "@/config/theme-defs/primitives"

/**
 * The single MUI theme for the entire app.
 * Uses CSS custom properties (cssVariables) so that light/dark switching
 * is handled via the `data-mui-color-scheme` attribute without re-creating
 * the theme object — compatible with MUI v6 `useColorScheme`.
 */

export const appTheme = createTheme({
  cssVariables: {
    colorSchemeSelector: "data-mui-color-scheme",
    cssVarPrefix: "template"
  },
  colorSchemes,
  typography,
  shadows,
  shape,
  components: {
    MuiListItemButton: {
      styleOverrides: {
        root: {
          gap: 4
        }
      }
    },
    MuiListItemIcon: {
      styleOverrides: {
        root: {
          minWidth: 0,
          marginRight: 4,
          "& .MuiSvgIcon-root": {
            fontSize: "1.1rem"
          }
        }
      }
    },
    MuiListItemText: {
      styleOverrides: {
        primary: {
          fontSize: "0.875rem"
        }
      }
    }
  }
})

export default appTheme
